<template>
    <!-- 组合 -->
    <div class="stock_group_wrap" @click.stop.prevent="handleClickGroupDetail">
        <div class="stock_group_title">
            <p
                :class="['stock_group_info', isGoUp(msg.profit_rate) ? 'to_red' : 'to_green']">
                <span>{{ msg.profit_rate }}%</span>
                <span>总收益</span>
            </p>
        </div>
        <div class="stock_group_detail">
            <div class="stock_group_list">
                <p class="simulation">
                    <span>{{ msg.group_name }}</span>
                </p>
                <div class="stock_group_info_right">
                    <p>
                        <span v-if="type == 'normal' || type == 'forwardShare'">{{ msg.max_stock_position_name }}</span>
                        <span v-else-if="type == 'forward'">近期讨论：{{ msg.comment_num }}条</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="stock_group_box">
            <div
                :class="['stock_group_btn', {
                    is_follow: is_follow === 'yes'
                }]"
                v-if="is_follow === 'no' || is_follow === 'yes'"
                @click.stop.prevent="followGroup"
            >{{ is_follow === 'yes'? '已关注': '关注' }}</div>
            <p class="stock_group_follow_nums">{{ follow_num }}人关注</p>
        </div>
    </div>
</template>
<script>
import { u_id } from "@/utils/urlQuery";
import { isGoUp, isLoginInfo } from "@/utils/index";
import userHomeApi from "@/api/user_home/index.js";
import { Toast, Dialog } from 'vant';
export default {
    name: "stockGroup",
    props: {
        msg: {
            type: Object,
            default: () => {
                return {}
            }
        },
        type: {
            type: String,
            default: "normal"
        }
    },
    data() {
        return {
            u_id,
            is_follow: "no",
            follow_num: 0,
            loading: false,
        }
    },
    created() {
        let msg = this.msg;
        this.is_follow = msg.is_follow;
        this.follow_num = msg.follow_num;
    },
    methods: {
        // 点击【已关注、关注】组合按钮
        async followGroup() {
			if(!isLoginInfo()) {
				return
			}
            if(this.loading) {
                return
            }
            this.loading = true;
            let status = this.is_follow;
            if(status == 'yes') {
                status = 'no';
            } else {
                status = 'yes';
            }
            
            if(this.u_id == this.msg.id && status == 'no') {
                Toast({
                    type: "html",
                    message: "<div class='stockGroupTips'>不能取消关注自己的模拟炒股</div>",
                    position: "bottom"
                })
                this.loading = false;
                return;
            }

            let res = await userHomeApi.setStockFollow({
                g_id: this.msg.id,
                status: status
            })
            if(res.rslt == 'succ') {
                this.is_follow = status;
                if(status == 'yes') {
                    this.follow_num += 1;
                    Dialog.alert({
                        title: '提示',
                        message: '订阅成功，调仓记录会第一时间推送！订阅后可在“模拟炒股-我订阅的组合”中查看',
                    }).then(() => {
                        // on close
                    });
                } else {
                    if(this.follow_num - 1 <= 0) {

                    } else {
                        this.follow_num -= 1;
                    }
                    Toast({
                        type: "html",
                        message: "<div class='stockGroupTips'>取消关注成功</div>",
                        position: "bottom"
                    })
                }
            }
            this.loading = false;
        },
        handleClickGroupDetail() {
            this.openNative("group_detail_page")
        },
        // 跳转APP页面
        openNative(type) {
            let params = {
                kind: type, // 类型
            };

            switch (type) {
                case "group_detail_page": // K线训练营
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native', params)
        },
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.stock_group_wrap {
    height: 60px;
    padding: 6px 12px 6px 6px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    border: 1px solid rgba(245, 245, 245, 1);
    display: flex;
    box-sizing: border-box;
    box-shadow: 0px 0px 14px 0px rgba(67, 67, 67, 0.07);

    .stock_group_title {
        width: 85px;
        height: 48px;
        margin-right: 10px;

        .stock_group_info {
            height: 48px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            box-sizing: border-box;

            &.to_green {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_down.png);
                background-size: 100%;
            }

            &.to_red {
                background: url(https://cdncos.aigupiao.com/assets/pc/img/bg_group_up.png);
                background-size: 100%;
            }

            >span {
                display: block;
                color: #ffffff;
                font-size: 13px;
                width: 100%;
                text-align: center;

                &:first-child {
                    font-size: 13px;
                    // font-weight: bold;
                }
            }
        }
    }

    .stock_group_detail {
        height: 100%;
        flex: 1;

        .stock_group_list {
            height: 100%;

            display: flex;
            flex-direction: column;
            justify-content: space-around;
            font-size: 12px;
        }

        .stock_group_info_right {
            font-size: 13px;
            color: #9f9f9f;

            >p {
                display: flex;
                align-items: center;
            }
        }
    }

    .stock_group_box {
        height: 100%;
        flex-direction: column;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding: 2px 0;
        box-sizing: border-box;

        .stock_group_btn {
            width: 44px;
            height: 20px;
            background: rgba(255, 255, 255, 1);
            border-radius: 3px;
            border: 1px solid rgba(254, 72, 74, 1);
            color: #fe484a;
            font-size: 12px;
            text-align: center;
            line-height: 20px;

            &.is_follow {
                color: #9f9f9f;
                border-color: #cfcfcf;
            }
        }

        >p {
            color: #9f9f9f;
            font-size: 12px;
        }

        .stock_group_follow_nums {
            margin-top: 3px;
            line-height: 16px;
            color: #939393; 
        }
    }
}
</style>
<style>
.stockGroupTips {
    white-space: nowrap;
}
</style>